import React from "react";
import styled from "styled-components";
import { Result, Button } from "antd";
import { ClockCircleOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const TokenExpired = () => {
  const navigate = useNavigate();

  const handleContactSupport = () => {
    window.location.href =
      "mailto:support@landlordops.com?subject=Tenant Chat Token Expired";
  };

  return (
    <Container>
      <Result
        icon={<ClockCircleOutlined style={{ color: "#faad14" }} />}
        title="⏰ Access Link Expired"
        subTitle={
          <div>
            <p>Your access link has expired.</p>
            <p>Please contact your landlord for a new secure link.</p>
          </div>
        }
        extra={[
          <Button
            type="primary"
            icon={<MailOutlined />}
            onClick={handleContactSupport}
            key="contact"
          >
            Contact Support
          </Button>,
          <Button onClick={() => navigate("/")} key="home">
            Go Home
          </Button>,
        ]}
      />
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 2rem;
`;

export default TokenExpired;
